import Text from '@zenbusiness/common-components/Text';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import { styled } from '@mui/material/styles';

import { FormattedText } from '#client/pages/EducationStudio/components/FormattedText/FormattedText';
import { FormattedTitle } from '#client/pages/EducationStudio/components/FormattedTitle/FormattedTitle';

const StyledListItem = styled(ListItem)(() => ({
  padding: 0,
  display: 'flex',
  alignItems: 'flex-start',
  marginBottom: '1rem',
  '&:last-child': {
    marginBottom: 0
  }
}));

const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: 0,
  backgroundColor: theme.palette.growthBrand.main,
  marginRight: '.5rem',
  width: '2rem',
  height: '2rem',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  [theme.breakpoints.down('md')]: {
    width: '1.5rem',
    height: '1.5rem'
  }
}));

export const NumberedListItem = ({ title, subText, number }) => (
  <StyledListItem>
    <StyledListItemIcon>
      <Text size="md" bold>{number}</Text>
    </StyledListItemIcon>
    <Box>
      <FormattedTitle variant="smallBold" marginBottom={1} dirtyTitle={title} />
      <FormattedText size="sm" dirtyText={subText} />
    </Box>
  </StyledListItem>
);

NumberedListItem.propTypes = {
  title: PropTypes.string.isRequired,
  subText: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired
};
